import React, { useMemo } from "react";
import fruity_pebbles from "./fruity_pebbles.png";

export default function FruityPebblesBoxesRain({
                                                   count = 25,
                                                   zIndex = 9999,
                                               }) {
    const boxes = useMemo(() => {
        return Array.from({ length: count }, (_, i) => ({
            id: i,
            left: Math.random() * 100,
            delay: Math.random() * -15,
            duration: 6 + Math.random() * 8,
            size: 50 + Math.random() * 60, // slightly smaller base
            rotate: Math.random() * 360,
            drift: -60 + Math.random() * 120,
        }));
    }, [count]);

    return (
        <div
            className="fp-box-rain"
            style={{ zIndex }}
            aria-hidden="true"
        >
            <style>{`
        .fp-box-rain {
          position: fixed;
          inset: 0;
          pointer-events: none;
          overflow: visible; /* FIX: prevent clipping */
        }

        .fp-box {
          position: absolute;
          top: -160px;
          left: clamp(8px, var(--left), calc(100vw - var(--size) - 8px));
          width: var(--size);
          transform: rotate(var(--rotate));
          animation: fp-fall var(--duration) linear var(--delay) infinite;
          will-change: transform;
        }

        .fp-box img {
          width: 100%;
          height: auto;
          display: block;
          filter: none; /* FIX: remove gray shadow */
        }

        @keyframes fp-fall {
          0% {
            transform: translateY(-160px) rotate(var(--rotate));
          }
          100% {
            transform: translateY(115vh)
              translateX(var(--drift))
              rotate(calc(var(--rotate) + 360deg));
          }
        }

        /* MOBILE FIXES */
        @media (max-width: 760px) {
          .fp-box {
            width: calc(var(--size) * 0.65);
            left: clamp(
              8px,
              var(--left),
              calc(100vw - (var(--size) * 0.65) - 8px)
            );
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .fp-box {
            animation: none;
            display: none;
          }
        }
      `}</style>

            {boxes.map((box) => (
                <div
                    key={box.id}
                    className="fp-box"
                    style={{
                        "--left": `${box.left}%`,
                        "--delay": `${box.delay}s`,
                        "--duration": `${box.duration}s`,
                        "--size": `${box.size}px`,
                        "--rotate": `${box.rotate}deg`,
                        "--drift": `${box.drift}px`,
                    }}
                >
                    <img src={fruity_pebbles} alt="Fruity Pebbles box" />
                </div>
            ))}
        </div>
    );
}